<template>
	<article class="publication">
		<main class="publication__body">
			<div class="publication__viewer">
				<iframe v-if="code" v-show="viewerLoaded" :src="iframeSrc" @load="onLoad"/>
				<b-spinner class="publication__spinner text-secondary" type="grow" v-show="!viewerLoaded" />
			</div>
		</main>
	</article>
</template>

<script>
import { isNil } from 'lodash';

export default {
	name: 'PublicationCard',
	props: {
		code: String,
		doi: String,
		citation: String,
		title:  String,
		authors:  String,
		journal:  String,
		year: String,
		abstract: String,

		uptitleMetaKey: {
			type: String,
			default: 'citation'
		},
		metas: {
			type: Array,
			default () {
				return [ 'year', 'doi' ]
			}
		}
	},
	computed: {
		uptitle () {
			return isNil(this.$props[this.uptitleMetaKey]) ? null : this.$props[this.uptitleMetaKey]
		},
		metaList () {
			return this.metas
				.filter( key => !isNil(this.$props[key]) )
					.map( key => ({ title: key, value: this.$props[key] }) )
		},
		iframeSrc () {
			return `https://library.contentednet.com/articles/${this.code}?minimal-ui=true`
		}
	},
	data () {
		return {
			viewerLoaded: false,
		}
	},
	methods: {
		onLoad ( event ) {
			this.viewerLoaded = true
		}
	}
}
</script>

<style scoped lang="scss">
$color-text: black;
$color-secondary: #6E84A3;

$font-size-lead: 1.17188rem;

.publication {
	display: flex;
	flex-direction: column;

	@media (min-width: 1024px) {
		font-size: $font-size-lead;
	}

	&__header {
		display: none;
		border-bottom: 1px solid $color-secondary;

		@media (min-width: 768px) {
			display: block;
		}

	}

	&__title {
		line-height: 1.4em;
	}

	&__body {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
	}

	&__author {
		&-wrap {
			display: none;
			justify-content: stretch;
			border-bottom: 1px solid $color-secondary;

			@media (min-width: 768px) {
				display: flex;
			}
		}

		&-icon {
			font-size: 1.5em;
		}

		&-title {
			display: none;
			text-transform: uppercase;
			font-weight: 200;
			letter-spacing: 1px;

			@media (min-width: 1024px) {
				display: inline;
			}
		}

		&-list {
			color: $color-text;
		}
	}

	&__metas {
		display: none;

		margin: 0;
		padding: 0;
		list-style: none;

		@media (min-width: 768px) {
			display: flex;
		}
	}

	&__meta {
		display: inline;

		&:not(:last-child) {
			border-right: 1px solid;
			padding-right: .8em;
			margin-right: .8em;
		}


		&-title {
			margin-right: .2em;
			text-transform: uppercase;
			letter-spacing: 1px;

			&::after {
				content: ":";
				display: inline-block;
				margin-right: .05em;
			}
		}
	}


	&__viewer {

		// min-height: 600px;
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		margin-left: -.5rem;
		margin-right: -.5rem;
		width: calc(100% + 1rem);

		iframe {
			height: 100%;
			width: 100%;
			border: none;
			flex-grow: 1
		}
	}

	&__spinner {
		position: absolute;
		top: calc(50% - 2rem);
		left: calc(50% - 2rem);
		width: 4rem;
		height: 4rem;
	}
}
</style>
